import React from "react";

class ImpactFestival extends React.Component {
  render() {
    const { state, setState } = this.props;

    return (
      <>
        <div className="row">
          <div className="col-md-6">
            <label className="pb-1">Event Start Date</label>
            <input
              onChange={(event) =>
                setState({ eventStartDate: event.target.value })
              }
              value={state.eventStartDate || ""}
              type="date"
              name="eventStartDate"
              className="form-control"
              required
            />
          </div>
          <div className="col-md-6">
            <label className="pb-1">Event End Date</label>
            <input
              onChange={(event) =>
                setState({ eventEndDate: event.target.value })
              }
              value={state.eventEndDate || ""}
              type="date"
              name="eventEndDate"
              className="form-control"
              required
            />
          </div>
        </div>
      </>
    );
  }
}

export default ImpactFestival;
